(function () {
  const form = document.getElementById("ps-form");
  if (!form) return;

  const customerId = form.dataset.customerId || "";
  const toggle = document.getElementById("ps-public-toggle");
  const urlContainer = document.getElementById("ps-public-url");
  const urlLink = document.getElementById("ps-public-url-link");
  const status = document.getElementById("ps-status");
  const saveBtn = form.querySelector(".ps-save");

  const PALATE_KEYS = [
    "palate_sweet_vanilla",
    "palate_fruity_bright",
    "palate_spicy_bold",
    "palate_nutty_chocolatey",
    "palate_oaky_woody",
    "palate_smoky_earthy",
    "palate_floral_delicate",
    "palate_tannic_dry",
    "palate_savory_umami",
    "palate_unique_experimental",
  ];

  const TEXT_FIELDS = ["name", "instagram_link", "quote", "bio"];

  function publicProfileURL() {
    return (
      window.location.origin +
      "/pages/profiles?customer_id=" +
      encodeURIComponent(customerId) +
      "&pb=0"
    );
  }

  function showPublicUrl() {
    if (!urlContainer || !urlLink) return;
    const href = publicProfileURL();
    urlLink.href = href;
    urlLink.textContent = href;
    urlContainer.style.display = "";
  }

  function hidePublicUrl() {
    if (urlContainer) urlContainer.style.display = "none";
  }

  function setStatus(text, kind) {
    if (!status) return;
    status.textContent = text;
    status.className = "ps-status" + (kind ? " ps-status-" + kind : "");
  }

  if (toggle && toggle.checked) showPublicUrl();

  // -------- Expertise Tags multi-select (max 5) --------
  (function setupExpertiseMultiselect() {
    const root = document.getElementById("ps-expertise");
    if (!root) return;
    const max = parseInt(root.dataset.max, 10) || 5;
    const toggleBtn = root.querySelector(".ps-ms-toggle");
    const panel = root.querySelector(".ps-ms-panel");
    const summary = root.querySelector(".ps-ms-summary");
    const checkboxes = Array.from(root.querySelectorAll(".ps-ms-checkbox"));
    const counter = document.querySelector(
      '.ps-ms-count[data-for="ps-expertise"]',
    );

    function refresh() {
      const selected = checkboxes.filter((cb) => cb.checked);
      const count = selected.length;
      checkboxes.forEach((cb) => {
        const disabled = !cb.checked && count >= max;
        cb.disabled = disabled;
        const opt = cb.closest(".ps-ms-option");
        if (opt) opt.classList.toggle("is-disabled", disabled);
      });
      if (count === 0) {
        summary.textContent = "Select up to " + max + "…";
        summary.classList.add("is-placeholder");
      } else {
        summary.textContent = selected.map((cb) => cb.value).join(", ");
        summary.classList.remove("is-placeholder");
      }
      if (counter) {
        counter.textContent = String(count);
        counter.classList.toggle("is-max", count >= max);
      }
    }

    function open() {
      panel.hidden = false;
      root.classList.add("is-open");
      toggleBtn.setAttribute("aria-expanded", "true");
    }
    function close() {
      panel.hidden = true;
      root.classList.remove("is-open");
      toggleBtn.setAttribute("aria-expanded", "false");
    }

    toggleBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      if (panel.hidden) open();
      else close();
    });
    panel.addEventListener("click", function (e) {
      e.stopPropagation();
    });
    checkboxes.forEach((cb) => cb.addEventListener("change", refresh));
    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) close();
    });

    refresh();
  })();

  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    saveBtn.disabled = true;
    setStatus("Saving…", "");

    const profileBody = {};
    TEXT_FIELDS.forEach((key) => {
      const el = form.elements[key];
      if (el) profileBody[key] = el.value;
    });
    PALATE_KEYS.forEach((key) => {
      const checked = form.querySelector('input[name="' + key + '"]:checked');
      if (checked) profileBody[key] = Number(checked.value);
    });
    // Expertise Tags (stored in the specialty_tags metafield) — send as an
    // array so values containing commas (e.g. "Finish Explorer (Sherry, Port,
    // Rum, Wine)") are preserved intact.
    const expertiseRoot = document.getElementById("ps-expertise");
    if (expertiseRoot) {
      profileBody.specialty_tags = Array.from(
        expertiseRoot.querySelectorAll(".ps-ms-checkbox:checked"),
      ).map((cb) => cb.value);
    }

    const publicValue = toggle ? toggle.checked : null;

    const requests = [
      fetch("/apps/barrelmasters/profile", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(profileBody),
      }),
    ];
    if (publicValue !== null) {
      requests.push(
        fetch("/apps/barrelmasters/visibility", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ public: publicValue }),
        }),
      );
    }

    try {
      const responses = await Promise.all(requests);
      const bodies = await Promise.all(
        responses.map((r) => r.json().catch(() => ({}))),
      );

      const failedIdx = responses.findIndex((r) => !r.ok);
      if (failedIdx !== -1) {
        const body = bodies[failedIdx] || {};
        const detail = body.fields
          ? Object.entries(body.fields)
              .map(([k, v]) => k + ": " + v)
              .join("; ")
          : body.error;
        setStatus(detail || "Failed to save. Please try again.", "error");
        return;
      }

      if (publicValue !== null) {
        if (publicValue) showPublicUrl();
        else hidePublicUrl();
      }
      setStatus("Saved.", "success");
    } catch (err) {
      console.error(err);
      setStatus("Network error. Please try again.", "error");
    } finally {
      saveBtn.disabled = false;
    }
  });

  // -------- Image upload (profile_picture + cover_image) --------

  const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];
  const MAX_BYTES = 5 * 1024 * 1024;

  function setImageStatus(field, text, kind) {
    const el = document.querySelector(
      '[data-image-status-for="' + field + '"]',
    );
    if (!el) return;
    el.textContent = text;
    if (kind) el.setAttribute("data-kind", kind);
    else el.removeAttribute("data-kind");
  }

  async function uploadImage(field, file) {
    if (!ALLOWED_TYPES.includes(file.type)) {
      setImageStatus(
        field,
        "Unsupported file type. Please use JPEG, PNG, or WebP.",
        "error",
      );
      return;
    }
    if (file.size > MAX_BYTES) {
      setImageStatus(field, "File too large. Maximum size is 5 MB.", "error");
      return;
    }

    const input = document.querySelector(
      'input[data-image-field="' + field + '"]',
    );
    if (input) input.disabled = true;
    setImageStatus(field, "Preparing upload…", "");

    try {
      // 1. Ask backend for a staged upload slot.
      const startRes = await fetch("/apps/barrelmasters/upload/start", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filename: file.name,
          mimeType: file.type,
          fileSize: file.size,
        }),
      });
      const startBody = await startRes.json().catch(() => ({}));
      if (!startRes.ok) {
        throw new Error(startBody.error || "Failed to start upload");
      }

      // 2. Upload the file directly to Shopify's staged GCS bucket.
      setImageStatus(field, "Uploading…", "");
      const formData = new FormData();
      (startBody.parameters || []).forEach((p) =>
        formData.append(p.name, p.value),
      );
      formData.append("file", file);
      const uploadRes = await fetch(startBody.url, {
        method: "POST",
        body: formData,
      });
      if (!uploadRes.ok) {
        throw new Error("Upload to Shopify failed (" + uploadRes.status + ")");
      }

      // 3. Tell backend the upload finished — it registers the file and
      // writes the new GID into the customer's metafield.
      setImageStatus(field, "Finalizing…", "");
      const finishRes = await fetch("/apps/barrelmasters/upload/finish", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          field,
          resourceUrl: startBody.resourceUrl,
          filename: file.name,
        }),
      });
      const finishBody = await finishRes.json().catch(() => ({}));
      if (!finishRes.ok || !finishBody.success) {
        throw new Error(finishBody.error || "Failed to finalize upload");
      }

      // 4. Update preview. If Shopify is still processing the upload,
      // imageUrl may be null — show a local object URL preview as a
      // best-effort hint, and tell the user it'll appear shortly.
      const preview = document.getElementById("ps-preview-" + field);
      if (preview) {
        if (finishBody.imageUrl) {
          preview.src = finishBody.imageUrl;
        } else {
          preview.src = URL.createObjectURL(file);
        }
      }
      setImageStatus(
        field,
        finishBody.imageUrl
          ? "Saved."
          : "Saved — your image will appear shortly.",
        "success",
      );
    } catch (err) {
      console.error("[profile-settings] upload failed:", err);
      setImageStatus(
        field,
        err.message || "Upload failed. Please try again.",
        "error",
      );
    } finally {
      if (input) {
        input.disabled = false;
        // Reset the input so picking the same file again still triggers change.
        input.value = "";
      }
    }
  }

  document.querySelectorAll("input[data-image-field]").forEach((input) => {
    input.addEventListener("change", function () {
      const file = input.files && input.files[0];
      if (!file) return;
      uploadImage(input.dataset.imageField, file);
    });
  });
})();
